import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_OtsDialog = _resolveComponent("OtsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasVIN)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: _normalizeClass(["btn tw-document-trigger-btn svg-container", _ctx.hasOTS ? 'badge-warning' : '']),
          onClick: _ctx.toggleShowOts,
          loading: _ctx.isLoading,
          floating: ""
        }, {
          loading: _withCtx(() => [
            _createVNode(_component_q_spinner_facebook)
          ]),
          default: _withCtx(() => [
            (_ctx.hasOTS && _ctx.otsCount > 0)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  color: "red",
                  floating: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.otsCount), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_icon, {
              name: "car_crash",
              size: "md",
              color: _ctx.hasOTS ? 'white' : 'white'
            }, null, 8, ["color"]),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.hasOTS ? 'Opérations Techniques Spéciales détectées' : 'Vérifier les OTS'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class", "onClick", "loading"]))
      : _createCommentVNode("", true),
    (_ctx.showOtsDialog)
      ? (_openBlock(), _createBlock(_component_OtsDialog, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}